import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '../../Badge/Badge';
import * as styles from './BaseSelect.module.scss';
const autoResizeInput = (event) => {
    const { style, value } = event.target;
    const minWidth = 2;
    style.width = `${minWidth + value.length}ch`;
};
export const InputContainer = ({ inputRef, inputValue, labelId, multi, onChange, onClickItem, onKeyDown, onRemoveValue, placeholder, selections, }) => {
    const hasSelections = selections.length > 0;
    const onChangeHandler = (event) => {
        autoResizeInput(event);
        onChange(event);
    };
    const renderPlaceholder = !hasSelections && !inputValue;
    const renderSingleValue = !multi && hasSelections && !inputValue;
    const renderMultiValue = multi &&
        hasSelections &&
        selections.map(({ label, value }) => (_jsx("div", { role: "status", onClick: onClickItem, children: _jsx(Badge, { title: label, onDismiss: () => onRemoveValue(value), size: "medium" }) }, value)));
    return (_jsxs("div", { className: styles.controlSelections, children: [renderPlaceholder && (_jsx("div", { className: styles.placeholder, children: placeholder })), renderSingleValue && (_jsx("div", { className: styles.controlText, children: selections[0].label })), renderMultiValue && renderMultiValue, _jsx("div", { className: styles.search, children: _jsx("input", { "aria-labelledby": labelId, type: "text", ref: inputRef, value: inputValue, onKeyDown: onKeyDown, onChange: onChangeHandler }) })] }));
};
